import { compareSpreadsheetColumnIds } from '~/_shared/types/spreadsheetData/spreadsheetColumns.helpers';
import type { TranslationFnc } from '~/_shared/utils/hooks';
import {
  type ChartMetric, type ChartMetricLocationCount, ChartMetricType, isChartMetricDemographic, isChartMetricLocationCount, isChartMetricSpreadsheetColumn,
} from './mapSettingsCharts.types';

export const areChartMetricsSubsetOf = (
  subsetMetrics: ReadonlyArray<ChartMetric>,
  supersetMetrics: ReadonlyArray<ChartMetric>,
): boolean => {
  for (const metricA of subsetMetrics) {
    const equalMetricB = supersetMetrics.find((metricB) => {
      if (metricA.type !== metricB.type) {
        return false;
      }

      if (isChartMetricSpreadsheetColumn(metricA) && isChartMetricSpreadsheetColumn(metricB)) {
        if (compareSpreadsheetColumnIds(metricA.column, metricB.column)) {
          return true;
        }
      }
      else if (isChartMetricDemographic(metricA) && isChartMetricDemographic(metricB)) {
        if (metricA.demographicId === metricB.demographicId) {
          return true;
        }
      }
      else if (isChartMetricLocationCount(metricA) && isChartMetricLocationCount(metricB)) {
        if (areLocationCountMetricsEqual(metricA, metricB)) {
          return true;
        }
      }
      return false;
    });

    if (!equalMetricB) {
      return false;
    }
  }

  return true;
};

export const getChartMetricTypeTranslation = (
  metricType: ChartMetricType,
  t: TranslationFnc,
) => {
  switch (metricType) {
    case ChartMetricType.SpreadsheetColumn:
      return t('Numeric Data Column');
    case ChartMetricType.Demographic:
      return t('Demographic');
    case ChartMetricType.LocationCount:
      return t('locationCount');
    default:
      return '';
  }
};

export const areLocationCountMetricsEqual = (
  metricA: ChartMetricLocationCount,
  metricB: ChartMetricLocationCount
): boolean => {
  if (
    (
      (metricA.column === undefined && metricB.column === undefined)
      || (metricA.column && metricB.column && compareSpreadsheetColumnIds(metricA.column, metricB.column))
    )
    && metricA.columnValue === metricB.columnValue
    && metricA.spreadsheetId === metricB.spreadsheetId // this is relevant only for ChartMetricType.LocationCount, otherwise it just compares if they are both undefined, which is fine
  ) {
    return true;
  }
  return false;
};
